export const isMac = (): boolean => {
  if (typeof window === 'undefined') return false

  const userAgent = navigator.userAgent.toLowerCase()
  return (
    /macintosh|mac os x/.test(userAgent) && !/iphone|ipad|ipod/.test(userAgent)
  )
}
